/* eslint eqeqeq: "off" */
/* eslint no-unused-vars: "off" */
import React, { useEffect, useRef, useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  Col,
  Input,
  Row,
  Table,
  Typography,
  Tooltip,
  AutoComplete,
  Divider,
  Select,
  Image,
  Modal,
  DatePicker,
  Checkbox,
  Switch,
  Skeleton,
  // Skeleton,
} from "antd";
import {
  SearchOutlined,
  PlusOutlined,
  EyeInvisibleFilled,
  EyeFilled,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { isEmpty } from "lodash";
import manageUsersLogo from "../../assets/images/empty-state-company-user.png";
import { HeaderData, items, usersCardList, usersHeaderData } from "./data";
import { emailIsValid } from "../Auth/validations";
import "./index.css";
import { BsQuestionCircle } from "react-icons/bs";
import { BiCalendar, BiEdit, BiTrashAlt } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import {
  loadActivities,
  loadOrganizationList,
  loadTokenExpiry,
  loadUserRole,
  loadUsers,
} from "../../store/organisation/actions";
import api from "../../helpers";
import { toast, ToastContainer } from "react-toastify";
import SimpleReactValidator from "simple-react-validator";
import { useHistory } from "react-router";
import useBeforeUnload from "../../components/Prompting";
import moment from "moment";

const ManageUsers = (props) => {
  const [loading, setLoading] = useState(false);
  const [usersTab, setUsersTab] = useState("Number of Users");

  const dispatch = useDispatch();
  const history = useHistory();
  const { RangePicker } = DatePicker;

  //organisation id from login response
  const userName = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userName);

  const userInfoDetails = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationId
    : "";
  const organisation = { organizationId: userInfoDetails };

  const userId = !isEmpty(userNameDetails) ? userNameDetails.user._id : "";

  const usersList = { userId: userId, organizationId: userInfoDetails };

  const roleId =
    userNameDetails &&
    userNameDetails !== undefined &&
    userNameDetails.user &&
    userNameDetails.user.rolePrivileges
      ? userNameDetails.user.rolePrivileges[0].roleId
      : "";

  useEffect(() => {
    dispatch(loadUsers(organisation));
    dispatch(loadActivities(organisation));
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //validations
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();

  //Reducer state

  const {
    user_role_list = [],
    user_activities = [],
    users_list = [],
    token_expiry_list = [],
    organization_list = [],
  } = useSelector((state) => state.Organisation);

  //State data section
  const [deleteUsers, setDeleteUsers] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [passwordShow, setPasswordShow] = useState(false);
  const [passwordId, setPasswordId] = useState("");
  const [userMode, setUserMode] = useState("User");
  const [multiLogin, setMultiLogin] = useState(false);
  const [tfaEnable, setTfaEnable] = useState(false);
  const [tfaWithMobileOtp, setTfaWithMobileOtp] = useState("");
  const [tfaWithAdminKey, setTfaWithAdminKey] = useState("");
  const [usersData, setUsersData] = useState({
    userId: "",
    name: "",
    userName: "",
    roleId: "",
    tokenId: "",
    password: "",
    mobileNumber: "",
  });
  const [email, setEmail] = useState("");
  const [userModal, setUserModal] = useState(false);
  const [error, setError] = useState(false);
  // const [response, setResponse] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [userRole, setUserRole] = useState([]);
  const [tokenExpiry, setTokenExpiry] = useState([]);
  const [transaction, setTransaction] = useState([]);
  const [yearWise, setYearWise] = useState([]);

  //Onchange state values
  const handleChange = (e) => {
    const { name, value } = e.target;

    const validationRules = {
      mobileNumber: /^[0-9]\d*\.?\d*$/,
    };
    if (validationRules[name]) {
      if (validationRules[name].test(value) || value === "") {
        setUsersData({
          ...usersData,
          [name]: value,
        });
      }
    } else {
      setUsersData({
        ...usersData,
        [name]: value,
      });
    }
  };

  const validationChange = ({ target: { value: inputValue } }) => {
    const mainInput = document.getElementById("main-input");
    const current_value = inputValue.replace(/ /g, "");
    setEmail(current_value);

    if (!emailIsValid(current_value)) {
      document.getElementById("error-panel").style.display = "block";
      mainInput.value = current_value;
    } else {
      document.getElementById("error-panel").style.display = "none";
    }
  };

  const roleOptions =
    user_role_list && user_role_list.length > 0
      ? user_role_list.map((data) => {
          return {
            label: data.roleName,
            value: data._id,
          };
        })
      : [];
  const tokenOptions =
    token_expiry_list && token_expiry_list.length > 0
      ? token_expiry_list.map((data) => {
          return {
            label: data.expiresName,
            value: data._id,
          };
        })
      : [];

  //users list
  const userListArray =
    users_list && users_list.length > 0
      ? users_list.map((data) => {
          const roleName =
            data.rolePrivileges && data.rolePrivileges.length > 0
              ? data.rolePrivileges[0].roleName
              : "";
          const roleId =
            data.rolePrivileges && data.rolePrivileges.length > 0
              ? data.rolePrivileges[0].roleId
              : "";

          return {
            roleName: (
              <h1 className="manage-business-button-label">{roleName}</h1>
            ),
            roleId: roleId,
            mobileNo: (
              <h1 className="manage-business-button-label">{data.mobileNo}</h1>
            ),
            name: <h1 className="manage-business-button-label">{data.name}</h1>,
            userName: (
              <h1 className="manage-business-button-label">{data.userName}</h1>
            ),
            password: (
              <div className="flex justify-between">
                <h1 className="mr-2">
                  {passwordShow && passwordId == data._id
                    ? data.password
                    : "******"}
                </h1>
                {passwordShow && passwordId == data._id ? (
                  <EyeFilled
                    onClick={() => {
                      setPasswordId(data._id);
                      setPasswordShow(false);
                    }}
                  />
                ) : (
                  <EyeInvisibleFilled
                    onClick={() => {
                      setPasswordId(data._id);
                      setPasswordShow(true);
                    }}
                  />
                )}
              </div>
            ),
            action: (
              <div className="flex">
                <BiEdit
                  style={{
                    opacity: data.isAdmin == true ? 2 : "",
                    pointerEvents: data.isAdmin == true ? "none" : "",
                  }}
                  onClick={() => {
                    setUserMode("Update");
                    setUserModal(true);
                    setUsersData({
                      userId: data.userId,
                      name: data.name,
                      userName: data.userName,
                      password: data.password,
                      mobileNumber: data.mobileNo,
                      tokenId: data.authExpiresId,
                      roleId: data.roleId,
                    });
                    setUserRole({
                      value: roleId,
                      label: roleName,
                    });
                    setTokenExpiry({
                      label: data.authExpiresName,
                      value: data.authExpiresId,
                    });
                    dispatch(loadUserRole(organisation));
                    dispatch(loadTokenExpiry());
                    dispatch(loadOrganizationList(usersList));
                  }}
                  className="text-[#067638] text-[18px] cursor-pointer"
                />
                <BiTrashAlt
                  onClick={() => {
                    setDeleteUsers(true);
                    setUsersData({
                      userId: data.userId,
                      tokenId: data.authExpiresId,
                      roleId: data.roleId,
                    });
                  }}
                  style={{
                    opacity: data.isAdmin == true ? 2 : "",
                    pointerEvents: data.isAdmin == true ? "none" : "",
                  }}
                  className="text-[red] ml-2 text-[18px] cursor-pointer"
                />
              </div>
            ),
            _id: data._id,
          };
        })
      : [];

  const usersDataList = {
    name: usersData.name,
    roleId: userRole.value,
    authExpiresId: tokenExpiry.value,
    organizationId: userInfoDetails,
    isAdminTwowayAuth: tfaWithAdminKey, //is false means --> otp or username, true --> admin key
    isotpTwowayAuth: tfaWithMobileOtp, // is false means --> otp , true --> both
    adminId: userId,
    mobileNo: usersData.mobileNumber,
    userName: multiLogin == true ? usersData.userName : "",
    password: multiLogin == true ? usersData.password : "",
  };
  const userListData = Object.keys(usersDataList).forEach(
    (k) => !usersDataList[k] && delete usersDataList[k]
  );

  console.log(userListData, "userListData");
  const addUsers = () => {
    if (simpleValidator.current.allValid()) {
      setIsButtonDisabled(true);
      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 3000);
      api
        .post("/auth/users/addorguser", usersDataList)
        .then((res) => {
          setTimeout(() => {
            dispatch(loadOrganizationList(usersList));
            dispatch(loadUsers(organisation));
            toast.success("Users added successfully");
            setUserModal(false);
          }, 1500);
          // setResponse(res.data);
          return res.data;
        })
        .catch((error) => {
          setError(error);
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error);
          toast.error(errorMsg || "There is a an issue while adding the users");
          Promise.reject(error);
        });
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  //update
  const usersUpdateDataList = {
    name: usersData.name,
    id: usersData.userId,
    roleId: userRole.value,
    authExpiresId: tokenExpiry.value,
    organizationId: userInfoDetails,
    isAdminTwowayAuth: tfaWithAdminKey, //is false means --> otp or username, true --> admin key
    isotpTwowayAuth: tfaWithMobileOtp, // is false means --> otp , true --> both
    adminId: userId,
    mobileNo: usersData.mobileNumber,
    userName: multiLogin == true ? usersData.userName : "",
    password: multiLogin == true ? usersData.password : "",
  };
  const userUpdateListData = Object.keys(usersUpdateDataList).forEach(
    (k) => !usersUpdateDataList[k] && delete usersUpdateDataList[k]
  );

  console.log(userUpdateListData, "userUpdateListData");
  //update Users
  const updateUsers = () => {
    if (simpleValidator.current.allValid()) {
      setIsButtonDisabled(true);
      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 3000);
      api
        .put("/auth/users/updateorgusers", usersUpdateDataList)
        .then((res) => {
          setTimeout(() => {
            dispatch(loadOrganizationList(usersList));
            dispatch(loadUsers(organisation));
            toast.success("Users updated successfully");
            setUserModal(false);
          }, 1500);
          // setResponse(res.data);
          return res.data;
        })
        .catch((error) => {
          setError(error);
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error);
          toast.error(errorMsg || "There is a an issue while adding the Users");
          Promise.reject(error);
        });
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  //delete users
  const deleteUsersDetails = () => {
    const deleteusersList = {
      userId: usersData.userId,
      deletedBy: userId,
      organizationId: userInfoDetails,
    };
    api
      .post("/auth/users/deleteorgusers", deleteusersList)
      .then((res) => {
        setTimeout(() => {
          dispatch(loadOrganizationList(usersList));
          dispatch(loadUsers(organisation));
          toast.error("Users Deleted successfully");
          setDeleteUsers(false);
        }, 1500);
        // setResponse(res.data);
        return res.data;
      })
      .catch((error) => {
        setError(error);
        Promise.reject(error);
      });
  };
  //api loader
  useEffect(() => {
    if (organization_list && !isEmpty(organization_list)) {
      const multiLoginChecked = organization_list.isEnableMultiLogin;
      setMultiLogin(multiLoginChecked);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organization_list]);

  //activities performed
  const [tableLoading, setTableLoading] = useState(false);
  const [rangeWiseChange, setRangeWiseChange] = useState(false);
  const [activitiesLoading, setActivitiesLoading] = useState(false);
  const [search, setSearch] = useState("");

  const activitiesRoutes = (data) => {
    history.push({
      pathname: "/settings/activity-vouchers",
      state: {
        organizationId: userInfoDetails,
        userId: userId,
        itemList: organisation,
        data: data,
      },
    });
  };

  //activities table
  const activitiesDataTable =
    user_activities && user_activities.length > 0
      ? user_activities.map((data) => {
          const activityMode =
            data && data.Activity ? data.Activity.slice(0, 1) : "";

          return {
            time: (
              <div
                style={{
                  fontFamily: "Poppins",
                  cursor: "pointer",
                }}
                onClick={() => activitiesRoutes(data)}
              >
                {data.timeofActivity
                  ? moment(data.timeofActivity).format("DD MMM YYYY hh:mm A")
                  : ""}
              </div>
            ),
            activity: (
              <div
                style={{
                  fontFamily: "Poppins",
                  backgroundColor:
                    activityMode == "C"
                      ? "#f0f1f3"
                      : activityMode == "D"
                      ? "#fbecec"
                      : activityMode == "E"
                      ? "#fff9e6"
                      : "#f0f1f3",
                  color:
                    activityMode == "C"
                      ? "#525a6a"
                      : activityMode == "D"
                      ? "#c33b3b"
                      : activityMode == "E"
                      ? "#e6b000"
                      : "#525a6a",
                  borderRadius: "4px",
                  padding: "4px 8px",
                  fontSize: "13px",
                  width: "80%",
                  cursor: "pointer",
                }}
                onClick={() => activitiesRoutes(data)}
              >
                {data.Activity}
              </div>
            ),
            activityName: data.Activity,
            transactionDetails: (
              <div
                className="flex justify-between cursor-pointer"
                onClick={() => activitiesRoutes(data)}
              >
                <h1
                  style={{
                    fontFamily: "Poppins",
                  }}
                >
                  {data.transactionDetails && data.transactionDetails.partyName
                    ? data.transactionDetails.partyName
                    : data.transactionDetails &&
                      data.transactionDetails.vendorName
                    ? data.transactionDetails.vendorName
                    : ""}
                </h1>
                <p>
                  ₹{" "}
                  {data.transactionDetails &&
                  data.transactionDetails.partyName &&
                  data.transactionDetails.netTotalAmount
                    ? data.transactionDetails.netTotalAmount
                    : data.transactionDetails &&
                      data.transactionDetails.NetAmount
                    ? data.transactionDetails.NetAmount
                    : ""}
                </p>
              </div>
            ),
            performedBy: (
              <div
                style={{
                  fontFamily: "Poppins",
                  cursor: "pointer",
                }}
                onClick={() => activitiesRoutes(data)}
              >
                {data.performedBy}{" "}
              </div>
            ),
            _id: data._id,
          };
        })
      : [];

  //activity rows
  const [activitiesRows, setActivitiesRows] = useState([
    {
      time: "",
      activity: "",
      transactionDetails: "",
      performedBy: "",
      activityName: "",
      _id: "",
    },
  ]);

  useEffect(() => {
    if (
      (activitiesDataTable && activitiesDataTable.length > 0) ||
      rangeWiseChange
    ) {
      setActivitiesRows(activitiesDataTable);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usersTab, user_activities, rangeWiseChange]);

  const handleSearch = (event) => {
    const filteredRows =
      activitiesDataTable.length > 0
        ? activitiesDataTable.filter((row) => {
            return row.activityName.toLowerCase().includes(event.target.value);
          })
        : [];
    setSearch(event.target.value);
    setActivitiesRows(filteredRows);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  useBeforeUnload({
    when: !isEmpty(userRole),
    message: "Are you sure you want to leave?",
  });

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Manage User | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid pb-[10px] rounded-md bg-[#ffffff] pb-10">
        {/* <Skeleton.Input
          style={{
            padding: "5px",
            width: "100%",
          }}
          active={true}
          size={"large"}
        > */}
        <Col span={24}>
          <div className="flex justify-between pl-[10px] pr-[10px] mt-3">
            <div className="flex">
              <div className="ml-2 account-sub-header">
                <h1 className="text-[18px] mb-[1px] font-semibold leading-tight">
                  Manage Users
                </h1>
              </div>
            </div>
          </div>
        </Col>
        {/* </Skeleton.Input> */}
        <Col span={24}>
          <Row className="pl-5 pr-5 mt-3">
            {usersCardList.map((data) => {
              return (
                <Col span={8} key={data.key} className="">
                  {/* <Skeleton.Input
                    style={{
                      marginRight: "5px",
                    }}
                    active={true}
                    size={"large"}
                    // block={true}
                  > */}
                  <div
                    className={
                      usersTab === data.label
                        ? "manage-business-button-label  poppins mr-2 ml-2 manage-users-select-card parties-card border rounded-md"
                        : "manage-business-button-label  poppins mr-2 ml-2 parties-card border rounded-md"
                    }
                    onClick={() => {
                      setUsersTab(data.label);
                      if (data.label === "Activities Performed") {
                        setTableLoading(true);
                        setActivitiesLoading(true);
                        setTimeout(() => {
                          setTableLoading(false);
                          setActivitiesLoading(false);
                        }, 2000);
                      }
                    }}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                        display: "flex",
                        marginBottom: "4px",
                        color: data.color,
                      }}
                    >
                      <p className={data.key !== 1 ? "mt-[2px]" : ""}>
                        {data.icon}
                      </p>
                      <h2 className={"ml-2 manage-business-button-label"}>
                        {data.label}
                      </h2>
                    </div>
                    <div
                      className={
                        data.key == 2
                          ? "flex justify-between mt-2"
                          : "flex justify-between"
                      }
                    >
                      <h1 className="manage-business-button-label font-semibold text-[18px]">
                        {data.key == 1
                          ? userListArray && userListArray.length
                          : activitiesDataTable && activitiesDataTable.length}
                      </h1>
                      {data.days ? (
                        <div
                          className={
                            usersTab === data.label
                              ? "manage-business-button-label pl-2 pr-2 pt-0.5 pb-0.5 border text-[blueviolet] rounded-md bg-[lightgray]"
                              : "manage-business-button-label pl-2 pr-2 pt-0.5 pb-0.5 border rounded-md bg-[lightgray]"
                          }
                        >
                          {data.days}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  {/* </Skeleton.Input> */}
                </Col>
              );
            })}
          </Row>
        </Col>
        {usersTab === "Activities Performed" ? (
          <>
            <Col span={24} className="mt-3">
              <Row
                className={
                  activitiesLoading
                    ? "flex justify-between mt-1 ml-4 pr-8"
                    : "flex justify-between mt-1 ml-4"
                }
              >
                <div className="flex">
                  {activitiesLoading ? (
                    <div
                      style={{
                        paddingRight: "30px",
                      }}
                    >
                      <Skeleton.Input
                        style={{
                          width: "110%",
                          height: "40px",
                        }}
                        active={true}
                        size={"large"}
                        // block={true}
                      ></Skeleton.Input>
                    </div>
                  ) : (
                    <Tooltip
                      rootClassName="text-[10px]"
                      title="Search by phone or name"
                      placement="bottom"
                    >
                      {searchOpen ? (
                        <AutoComplete
                          style={{
                            width: 240,
                            marginRight: "10px",
                            fontFamily: "Poppins",
                          }}
                        >
                          <Input.Search
                            size="large"
                            placeholder="Search by Party Name/ Invoice No."
                            style={{
                              fontFamily: "Poppins",
                            }}
                            name="search"
                            value={search}
                            className="manage-business-button-label "
                            onChange={(e) => handleSearch(e)}
                          />
                        </AutoComplete>
                      ) : (
                        <div
                          onClick={() => setSearchOpen(true)}
                          className="border rounded-md h-[40px] mr-3 pt-2 pb-2 pr-3 pl-3 cursor-pointer"
                        >
                          <SearchOutlined size={16} />
                        </div>
                      )}
                    </Tooltip>
                  )}
                  {activitiesLoading ? (
                    <div
                      style={{
                        paddingRight: "30px",
                      }}
                    >
                      <Skeleton.Input
                        style={{
                          width: "110%",
                          height: "40px",
                        }}
                        active={true}
                        size={"large"}
                        // block={true}
                      ></Skeleton.Input>
                    </div>
                  ) : (
                    <Select
                      style={{
                        width: 200,
                        height: 40,
                      }}
                      allowClear
                      value={transaction}
                      onChange={(e) => setTransaction(e)}
                      placeholder="Select Transaction"
                      // dropdownRender={(menu) => (
                      //   <>
                      //     {menu}
                      //     <Divider
                      //       style={{
                      //         margin: "8px 0",
                      //       }}
                      //     />
                      //   </>
                      // )}
                      className="manage-business-button-label"
                      options={items}
                    />
                  )}
                  {activitiesLoading ? (
                    <div
                      style={{
                        paddingRight: "30px",
                      }}
                    >
                      <Skeleton.Input
                        style={{
                          width: "110%",
                          height: "40px",
                        }}
                        active={true}
                        size={"large"}
                      ></Skeleton.Input>
                    </div>
                  ) : (
                    <RangePicker
                      style={{
                        width: 220,
                        height: 40,
                      }}
                      onChange={(date, dateString) => {
                        setYearWise(dateString);
                        if (dateString.length > 1 && !isEmpty(dateString[0])) {
                          dispatch(
                            loadActivities({
                              organizationId: userInfoDetails,
                              dateFrom: dateString[0],
                              dateTo: dateString[1],
                            })
                          );
                          setRangeWiseChange(true);
                          setTimeout(() => {
                            setRangeWiseChange(false);
                          }, 2000);
                        } else if (
                          dateString.length > 0 &&
                          isEmpty(dateString[0])
                        ) {
                          dispatch(
                            loadActivities({
                              organizationId: userInfoDetails,
                            })
                          );
                        }
                      }}
                      allowClear
                      suffixIcon={<BiCalendar size={18} />}
                      placeholder="Select Calendar"
                      className="ml-2 manage-business-button-label"
                    />
                  )}
                  {/* <Select
                    style={{
                      width: 250,
                      height: 40,
                    }}
                    value={yearWise}
                    onChange={(e)=> setYearWise(e)}
                    allowClear
                    suffixIcon={<BiCalendar size={18} />}
                    placeholder="Select Calendar"
                    className="ml-2"
                    // dropdownRender={(menu) => (
                    //   <>
                    //     {menu}
                    //     <Divider
                    //       style={{
                    //         margin: "8px 0",
                    //       }}
                    //     />
                    //   </>
                    // )}
                    options={[]}
                  /> */}
                </div>
              </Row>
            </Col>
            <Col
              span={24}
              className="p-4 mb-10"
              style={{
                fontFamily: "Poppins",
              }}
            >
              <Table
                style={{
                  overflow: "hidden",
                }}
                rootClassName="activities-table manage-business-button-label"
                bordered
                columns={HeaderData}
                dataSource={
                  activitiesRows &&
                  activitiesRows.length > 0 &&
                  !isEmpty(activitiesRows[0].activity)
                    ? activitiesRows
                    : []
                }
                // sortDirections={"ascend"}
                loading={tableLoading ? true : false}
                showSorterTooltip={{
                  target: "sorter-icon",
                }}
                scroll={{ y: activitiesRows.length > 2 ? 150 : "100%", x: 765 }}
              />
            </Col>
          </>
        ) : userListArray && userListArray.length > 0 ? (
          <Col span={24} className="p-4">
            <Table
              style={{
                overflow: "hidden",
                fontFamily: "Poppins",
              }}
              bordered
              rootClassName="manage-business-button-label"
              columns={usersHeaderData}
              // dataSource={TableData}
              dataSource={userListArray}
              // sortDirections={"ascend"}
              loading={loading ? true : false}
              showSorterTooltip={{
                target: "sorter-icon",
              }}
              pagination={false}
              // rowSelection={{}}
              scroll={{ y: 210, x: 700 }}
            />
            <div className="text-center mt-6">
              <p className="text-[12px] mt-2 account-sub-header font-semibold text-[#667085]">
                Manage your business more efficiently with full control and
                vision
              </p>
            </div>
            <div className="text-center mt-4 mb-[100px]">
              <div className="flex justify-center">
                <div
                  onClick={() => {
                    setUserModal(true);
                    setUserMode("Add");
                    dispatch(loadUserRole(organisation));
                    dispatch(loadTokenExpiry());
                    dispatch(loadOrganizationList(usersList));
                    setUsersData({
                      name: "",
                      userName: "",
                      password: "",
                      mobileNumber: "",
                    });
                    setUserRole([]);
                    setTokenExpiry([]);
                  }}
                  className="manage-business-button-label border bg-[#1a276dd4] hover:bg-[#7163c1] text-[#ffffff] rounded-md ml-3 pl-6 pr-6 p-1.5 cursor-pointer"
                >
                  <PlusOutlined /> Add New User
                </div>
                {/* <div
                  onClick={() => {
                    setUserModal(true);
                    setUserMode("CA");
                  }}
                  className="border rounded-md hover:bg-[#efefef] ml-3 pl-6 pr-6 p-1 cursor-pointer"
                >
                  <PlusOutlined /> Add New CA
                </div> */}
              </div>
            </div>
          </Col>
        ) : (
          <Col span={24} className="flex pt-3 justify-center">
            <div>
              <Image
                src={manageUsersLogo}
                height={220}
                width={600}
                preview={false}
              />
              <div className="text-center mt-2">
                <h1 className="text-[18px] account-sub-header font-bold">
                  Give access to users and monitor their actions
                </h1>
                <p className="text-[11px] mt-2 account-sub-header font-semibold text-[#667085]">
                  Manage your business more efficiently with full control and
                  vision
                </p>
              </div>
              <div className="text-center mt-4">
                <div className="flex justify-center">
                  <div
                    onClick={() => {
                      setUserModal(true);
                      setUserMode("Add");
                      dispatch(loadUserRole(organisation));
                      dispatch(loadTokenExpiry());
                      dispatch(loadOrganizationList(usersList));
                      setUsersData({
                        name: "",
                        userName: "",
                        password: "",
                        mobileNumber: "",
                      });
                      setUserRole([]);
                      setTokenExpiry([]);
                    }}
                    className="border bg-[#1a276dd4] hover:bg-[#7163c1] text-[#ffffff] rounded-md ml-3 pl-6 pr-6 p-1.5 cursor-pointer"
                  >
                    <PlusOutlined /> Add New User
                  </div>
                  {/* <div
                    onClick={() => {
                      setUserModal(true);
                      setUserMode("CA");
                    }}
                    className="border rounded-md hover:bg-[#efefef] ml-3 pl-6 pr-6 p-1 cursor-pointer"
                  >
                    <PlusOutlined /> Add New CA
                  </div> */}
                </div>
              </div>
            </div>
          </Col>
        )}
        {/* Parties input section with bulk actions */}

        <Modal
          open={userModal}
          title={userMode === "Update" ? "Update User" : "Add User"}
          onOk={() => {
            if (userMode === "Update") {
              updateUsers();
            } else {
              addUsers();
            }
          }}
          rootClassName="manage-business-button-label"
          closeIcon
          okButtonProps={{
            disabled: isButtonDisabled ? true : false,
          }}
          maskClosable={false}
          okText={userMode === "Update" ? "Update" : "Save"}
          className="mt-[-80px]"
          onCancel={() => setUserModal(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{
              borderWidth: "0.2px",
              width: "110%",
              marginLeft: "-24px",
              marginTop: "-2px",
            }}
          />
          <Col span={24} className="mb-10">
            <Row>
              {!isEmpty(error) ? (
                <Col md={24} sm={24} xs={24} className="pr-4 mb-3">
                  <Typography className="input-label text-[red]">
                    {!isEmpty(error) ? error.error : ""}
                  </Typography>
                </Col>
              ) : (
                ""
              )}
              <Col span={12} md={12} sm={24} xs={24} className="pr-4 mb-1">
                <Typography className="input-label">
                  Name <p className="text-[red] mx-1">*</p>
                </Typography>
                <Input
                  name="name"
                  value={usersData.name}
                  onChange={(e) => handleChange(e)}
                  placeholder="Enter Name"
                  className="p-2 font-semibold manage-business-button-label"
                />
                <p className="text-start text-[red] mt-2 mb-2">
                  {simpleValidator.current.message(
                    "name",
                    usersData.name,
                    "required"
                  )}
                </p>
              </Col>

              <Col span={12} md={12} xs={12} className="pr-4 mb-1">
                <Typography className="input-label">
                  Mobile Number
                  <p className="text-[red] mx-1">*</p>
                </Typography>
                <Input
                  name="mobileNumber"
                  maxLength={10}
                  value={usersData.mobileNumber}
                  onChange={(e) => handleChange(e)}
                  placeholder="Enter User's Mobile Number"
                  className="p-2 font-semibold manage-business-button-label"
                />
                <p className="text-start text-[red] mt-2 mb-2">
                  {simpleValidator.current.message(
                    "mobileNumber",
                    usersData.mobileNumber,
                    "required"
                  )}
                </p>
              </Col>
              <Col span={12} md={12} xs={12} className="pr-4 mt-2 mb-1">
                <Typography className="input-label">
                  User Role <p className="text-[red] mx-1">*</p>
                </Typography>
                <Select
                  value={userRole}
                  onChange={(value, option) =>
                    setUserRole({ value, label: option.label })
                  }
                  placeholder="Select User Role"
                  options={roleOptions}
                  className="h-[40px] w-[100%] font-semibold manage-business-button-label"
                />
                <p className="text-start text-[red] mt-2 mb-2">
                  {simpleValidator.current.message(
                    "userRole",
                    userRole,
                    "required"
                  )}
                </p>
              </Col>
              <Col span={12} md={12} xs={12} className="pr-4 mt-2 mb-1">
                <Typography className="input-label">
                  Token Expiry <p className="text-[red] mx-1">*</p>
                </Typography>
                <Select
                  value={tokenExpiry}
                  onChange={(value, option) =>
                    setTokenExpiry({ value, label: option.label })
                  }
                  placeholder="Select Token Expiry"
                  options={tokenOptions}
                  className="h-[40px] w-[100%] font-semibold manage-business-button-label"
                />
                <p className="text-start text-[red] mt-2 mb-2">
                  {simpleValidator.current.message(
                    "tokenExpiry",
                    tokenExpiry,
                    "required"
                  )}
                </p>
              </Col>
              {multiLogin == true ? (
                <>
                  <Col
                    span={24}
                    md={24}
                    sm={24}
                    xs={24}
                    className="border border-b-2 border-x-0 border-t-0 pt-1 pb-1 mb-3"
                  >
                    <h1
                      style={{ fontFamily: "Poppins" }}
                      className="text-[13px] uppercase font-semibold manage-business-button-label "
                    >
                      Login Credentials
                    </h1>
                  </Col>
                  <Col span={12} md={12} sm={24} xs={24} className="pr-4 mb-3">
                    <Typography className="input-label">User Name</Typography>
                    <Input
                      name="userName"
                      value={usersData.userName}
                      onChange={(e) => handleChange(e)}
                      placeholder="Enter user name"
                      className="p-2 mt-1 font-semibold manage-business-button-label "
                    />
                  </Col>

                  <Col span={12} md={12} xs={12} className="pr-4 mb-3">
                    <Typography className="input-label">Password</Typography>
                    <Input.Password
                      name="password"
                      // maxLength={10}
                      value={usersData.password}
                      onChange={(e) => handleChange(e)}
                      placeholder="Enter password"
                      className="p-2 mt-1 font-semibold manage-business-button-label "
                    />
                  </Col>

                  <Col span={12} className="mb-3 mt-1">
                    <div
                      onClick={() => setTfaEnable(!tfaEnable)}
                      className="cursor-pointer flex justify-between"
                    >
                      <Typography className="input-label text-[13px]">
                        TFA Enable
                      </Typography>
                      <Switch
                        value={tfaEnable}
                        onChange={(checked) => setTfaEnable(checked)}
                      />
                    </div>
                  </Col>
                  {tfaEnable ? (
                    <Col span={24}>
                      <Row>
                        <Col span={12} className="mb-3 mt-1">
                          <div
                            // onClick={() => setTfaEnable(!tfaEnable)}
                            className="cursor-pointer flex"
                          >
                            <Checkbox
                              value={tfaWithMobileOtp}
                              onChange={(e) =>
                                setTfaWithMobileOtp(e.target.checked)
                              }
                            />
                            <Typography
                              style={{ fontFamily: "Poppins" }}
                              className="text-[12px] ml-1 mt-[2px]"
                            >
                              TFA with mobile OTP
                            </Typography>
                          </div>
                        </Col>
                        <Col span={12} className="mb-3 mt-1">
                          <div
                            // onClick={() => setTfaEnable(!tfaEnable)}
                            className="cursor-pointer flex"
                          >
                            <Checkbox
                              value={tfaWithAdminKey}
                              onChange={(e) =>
                                setTfaWithAdminKey(e.target.checked)
                              }
                            />
                            <Typography
                              style={{ fontFamily: "Poppins" }}
                              className="text-[12px] ml-1 mt-[2px]"
                            >
                              TFA with Admin Key
                            </Typography>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                ""
              )}

              {userMode == "CA" ? (
                <Col span={12} md={12} xs={12} className="pr-4 mt-2 mb-3">
                  <Typography className="input-label">E-mail</Typography>
                  <Input
                    name="email"
                    value={email}
                    id="main-input"
                    onChange={validationChange}
                    placeholder="Enter Email"
                    className="p-2 mt-1"
                  />
                  <div
                    id="error-panel"
                    style={{
                      display: "none",
                      // marginTop: "-15px",
                      marginBottom: "10px",
                    }}
                  >
                    {isEmpty(email) ? (
                      ""
                    ) : (
                      <p className="text-start text-[#ff0000]">
                        The email or mobile field is not valid
                      </p>
                    )}
                  </div>
                </Col>
              ) : (
                <Col span={24} className="flex terms-conditions-card mt-1 pr-3">
                  <h1 className=" manage-business-button-label flex font-bold ml-10 text-center">
                    Note:
                    <p className=" manage-business-button-label flex font-medium ml-2">
                      To know more about Admin's permissions click
                      <p
                        onClick={() => {
                          history.push("/settings/user-roles");
                        }}
                        className=" manage-business-button-label cursor-pointer flex ml-1 text-[blue]"
                      >
                        User Roles <BsQuestionCircle className="mt-1 ml-1" />
                      </p>
                    </p>
                  </h1>
                </Col>
              )}
            </Row>
          </Col>

          <Divider
            style={{
              borderWidth: "0.2px",
              width: "110%",
              marginLeft: "-24px",
              marginTop: "-10px",
            }}
          />
        </Modal>
        <Modal
          open={deleteUsers}
          onOk={() => {
            deleteUsersDetails();
          }}
          closeIcon
          maskClosable={false}
          rootClassName="p-18 h-[350px]"
          okText={"Yes, Delete"}
          cancelText={"No"}
          onCancel={() => setDeleteUsers(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <div className="text-center flex justify-center">
              <div className="mr-3">
                <OkBtn />
              </div>
              <CancelBtn />
            </div>
          )}
          width={500}
        >
          <div className="text-center w-[100%]">
            <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
            <h1 className="text-center text-[18px] font-bold">
              Are you sure you want to delete this user?
            </h1>
            <p className="text-center text-[14px] mt-2">
              All unsaved changes will be lost!
            </p>
          </div>
        </Modal>
      </Row>
      {/* <Prompt
        when={!isEmpty(userRole)}
        message="Are you sure you want to leave?"
      /> */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{
          fontSize: "12px",
        }}
        pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};
ManageUsers.propTypes = {
  location: PropTypes.any,
};

export default ManageUsers;
